import { Panel } from '../panel';
import { InlineFormSectionHeader } from './inline-form-section-header';
import { InlineFormSectionFooter } from './inline-form-section-footer';
import type { InlineFormSectionProps } from '../../../types/inline-form-section.types';

/** Keep a small form's heading, fields and action hierarchy in one shared card. */
export function InlineFormSection({
  title,
  description,
  icon,
  headerAction,
  children,
  bodyClassName = '',
  status,
  secondaryAction,
  actions,
}: InlineFormSectionProps) {
  return (
    <section aria-label={title}>
      <Panel variant="neutral" appearance="outline" shadow="sm">
        <InlineFormSectionHeader
          title={title}
          description={description}
          icon={icon}
          headerAction={headerAction}
        />
        <div className={`space-y-6 p-4 sm:p-6 ${bodyClassName}`}>
          {children}
        </div>
        {(Boolean(status) || Boolean(secondaryAction) || Boolean(actions)) && (
          <InlineFormSectionFooter
            status={status}
            secondaryAction={secondaryAction}
            actions={actions}
          />
        )}
      </Panel>
    </section>
  );
}
